// extracted by mini-css-extract-plugin
export default {"wrapper":"Kx7C6OEVepzfF8oyrGni","inputTable":"YmH2bFhnqjou376UN9iW","newInputTable":"N9OgK_PYfgLwWSescbLI","iconWrapper":"NP73zdBCOhCwp3tsBoW9","icon":"ry6XbzP7uNe87nPyN7Lw"};